import React from 'react';
import { Check } from 'lucide-react';

export const FilterPanel = ({ title, k, chips, selected, onToggle }) => (
  <div className="bg-[#141414] border border-white/10 rounded-2xl p-4 min-w-0" data-testid={`filter-panel-${k}`}>
    <h2 className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/40 font-semibold mb-3">{title}</h2>
    <div className="flex flex-wrap gap-1.5 max-h-[156px] overflow-y-auto pr-1 gallery-scroll">
      {chips.map(([v, c]) => {
        const on = selected.has(v);
        return (
          <button
            key={v}
            type="button"
            aria-pressed={on}
            onClick={() => onToggle(k, v)}
            data-testid={`chip-${k}-${v.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}
            className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs transition-colors duration-200 ${
              on
                ? 'border-[#FF7A00] bg-[#FF7A00]/10 text-[#FF7A00] font-semibold'
                : 'border-white/10 bg-white/[0.03] text-white/70 hover:border-[#FF7A00]/40 hover:text-white'
            }`}
          >
            {on && <Check size={12} />}
            {v}
            <i className={`not-italic font-mono ml-0.5 ${on ? 'text-[#FF7A00]/70' : 'text-white/30'}`}>{c}</i>
          </button>
        );
      })}
    </div>
  </div>
);
